import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * 개발기(dev·stg 빌드) 라우트 이동 콘솔 로거 — 딥링크/back 디버깅 보조.
 *
 * WebView 앱은 딥링크 콜드스타트처럼 chrome://inspect 를 붙이기 어려운 상황이 있다. SPA 라우트 이동은
 * React Router 의 pushState 라 native 페이지 로드가 아니어서 원래 logcat 에 안 찍힌다. 이 로거가
 * 라우트 이동을 `console.log` 로 흘리면, native(debug 빌드)가 그걸 logcat 으로 포워딩한다
 * (`WebViewConfigurator` 가 console.* 를 `window.maketrend.consoleLog` 로 넘기고
 * `MaketrendJsBridge.consoleLog` 가 DEBUG 에서 Logcat 출력 → 태그 `Maketrend.webview`, `[console]` prefix).
 * 확인: `adb logcat -s Maketrend.webview | grep "\[route\]"`.
 *
 * prd 빌드에서는 찍지 않는다(로그 누출·노이즈 방지). `import.meta.env.DEV` 는 로컬 `vite dev` 에서만
 * true 라 배포된 개발기(`build-dev`) 에선 false → `MODE` 기준으로 게이트한다(prd 만 제외).
 */
const RouteLogger = () => {
  const location = useLocation();

  useEffect(() => {
    if (import.meta.env.MODE === "prd") return;
    console.log("[route]", location.pathname + location.search);
  }, [location]);

  return null;
};

export default RouteLogger;
